import React, { useState, useEffect } from "react";
import { Row, Col, Container, CardBody, Card } from "reactstrap";
import URLSearchParams from "@ungap/url-search-params";
import { Link} from "react-router-dom";
import { AvForm, AvField } from "availity-reactstrap-validation";
import CMSLogo from "../../assets/images/long-logo.svg";
import { FaHome } from "react-icons/fa";


const ResetPassword = (props) => {
  const [Password, setPassword] = useState("");
  const [Password2, setPassword2] = useState("");
  const [PasswordError, setPasswordError] = useState(null);
  const [RetypePasswordError, setRetypePasswordError] = useState(null);
  const [queryCode, setQueryCode] = useState();
  const [AcountBlock, setAcountBlock] = useState(null);

  const queryString = new URLSearchParams(window.location.search);
  useEffect(() => {
    let code = queryString.get("code");
    if (code) {
      expireCheck(code);
      setQueryCode(code);
    }

    return function cleanup() {};
  }, []);

  function isValidPassword(password) {
    const lengthRegex = /.{12,}/;
    const uppercaseRegex = /[A-Z]/;
    const lowercaseRegex = /[a-z]/;
    const digitRegex = /\d/;
    const specialCharRegex = /[^A-Za-z0-9]/; 
    const hasValidLength = lengthRegex.test(password);
    const hasUppercase = uppercaseRegex.test(password);
    const hasLowercase = lowercaseRegex.test(password);
    const hasDigit = digitRegex.test(password);
    const hasSpecialChar = specialCharRegex.test(password);  
    const categoryCount = [hasUppercase, hasLowercase, hasDigit, hasSpecialChar].filter(Boolean).length;
    return hasValidLength && categoryCount >= 3;
  }

  const expireCheck = async (queryCode) => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

    var urlencoded = new URLSearchParams();
    urlencoded.append("code", queryCode);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: urlencoded,
      redirect: "follow",
    };

    let loginResponse = await fetch(
      `${process.env.REACT_APP_TOKRI_API_URL}/api/password/code/check`,
      requestOptions
      ).then((response) => {
      return response.text();
      }).catch((error)=>console.log("error",error));

    let responseMessage = JSON.parse(loginResponse);
    if (responseMessage.errors) {
      props.history.push("/link-expired");
    } else if (responseMessage.exipred) {
      props.history.push("/link-expired");
    }
  };

  const passwordcheck = (e) => {
    if (e.target.value.length > 0) {
      if (Password2.length > 0 && e.target.value === Password2) {
        setRetypePasswordError(null);
      } else {
        if(Password2.length > 0){
        setRetypePasswordError('Your password does not match');
        }
      }
      setPassword(e.target.value);
      if (isValidPassword(e.target.value)) {
        setPasswordError(null);
      } else {
        setPasswordError(
          "Password must be at least 12 characters and include at least 3 of the following: uppercase letters, lowercase letters, numbers or special characters."
        );
      }
    } else {
      setPasswordError("Please enter password");
    }
  };

  const passwordRecheck = (e) => {
    if (e.target.value.length > 0) {
      setPassword2(e.target.value)
      if (e.target.value === Password) {
        setRetypePasswordError(null);
      } else {
        setRetypePasswordError("Your password does not match");
      }
    } else {
      setRetypePasswordError("Please enter password");
    }
  };

  // handleValidSubmit
  const handleSubmit = async () => {
    if(PasswordError || RetypePasswordError){
      return
    }
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    var urlencoded = new URLSearchParams();
    urlencoded.append("password", Password);
    urlencoded.append("code", queryCode);
    urlencoded.append("password_confirmation", Password2);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: urlencoded,
      redirect: "follow",
    };

    let loginResponse = await fetch(
      `${process.env.REACT_APP_TOKRI_API_URL}/api/password/reset`,
      requestOptions
    ).then((response) => {
      return response.text();
    }).catch((error)=>console.log("error",error));
    let responseMessage = JSON.parse(loginResponse);
    if(responseMessage?.old_password_used){
      setAcountBlock(responseMessage?.message)
    }else if(responseMessage?.exipred){
      setAcountBlock(responseMessage?.message)
    }else if(responseMessage?.errors){
      setAcountBlock(responseMessage?.errors[0])
    }else if (!responseMessage?.errors) {
      props.history.push("/success-password");
    }
  };

  return (
    <React.Fragment>
      <div className="home-btn d-none d-sm-block">
        <Link to="/" className="text-dark">
          <FaHome size={32} />
        </Link>
      </div>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row>
            <Col lg={12}>
              <div className="text-center">{/* div for logo etc */}</div>
            </Col>
          </Row>
          <Row className="align-items-center justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card>
                <CardBody className="p-5">
                  <Link to="/" className="mb-2 d-block auth-logo">
                    <img
                      style={{ marginLeft: "auto", marginRight: "auto" }}
                      src={CMSLogo}
                      alt=""
                      height="40"
                      className="logo logo-dark"
                    />
                  </Link>
                  <div className="text-center mt-3">
                    <h5 style={{
                        color: "#000000 !important",
                        fontSize: 15,
                        margin: 0,
                      }}>RESET PASSWORD</h5>
                    <p
                      style={{ color: "#000000 !important" }}
                      className="text-muted"
                    >
                      Please enter your new password
                    </p>
                  </div>
                  <div className="p-2 mt-4">
                    <AvForm className="form-horizontal">
                      <div className="mb-3">
                      <label className="form-label">Password</label>
                        <input 
                          className="password-input"
                          id="password"
                          type="password"
                          placeholder="Enter Password"
                          onChange={(e) => {
                            passwordcheck(e);
                            setAcountBlock(null)
                          }}
                        />
                        {PasswordError ? (
                          <div
                            style={{
                              fontSize: 12,
                              color: "red",
                              fontWeight: 400,
                            }}
                          >
                            {PasswordError}
                          </div>
                        ) : (
                          ""
                        )}
                      </div>

                      <div className="mb-3">
                      <label className="form-label">Retype Password</label>
                        <input 
                          className="password-input"
                          id="password-retype"
                          type="password"
                          placeholder="Enter Password"
                          onChange={(e) => {
                            passwordRecheck(e);
                            setAcountBlock(null)
                          }}
                        />
                        {RetypePasswordError ? (
                          <div
                            style={{
                              fontSize: 12,
                              color: "red",
                              fontWeight: 400,
                            }}
                          >
                            {RetypePasswordError}
                          </div>
                        ) : (
                          ""
                        )}
                        {AcountBlock ? (
                        <div
                          style={{
                            fontSize: 12,
                            color: "red",
                            fontWeight: 400,
                            marginTop: 2,
                          }}
                        >
                          {AcountBlock}
                        </div>
                      ) : (
                        ""
                      )}
                      </div>

                      <div className="mt-3">
                        <button
                          className="btn btn-primary w-100 waves-effect waves-light"
                          type="submit"
                          onClick={() => {
                            handleSubmit();
                          }}
                        >
                          Submit
                        </button>
                      </div>
                      <div
                        style={{
                          justifyContent: "space-around",
                          display: "flex",
                        }}
                      >
                        <div className="mt-3 ">
                          <Link
                            to="/"
                            className="text-dark  text-decoration-underline"
                          >
                            Back to login
                          </Link>
                        </div>

                        <div className="mt-3  text-decoration-underline">
                          <Link to="/reset-password" className="text-dark">
                            Send New link
                          </Link>
                        </div>
                      </div>
                    </AvForm>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ResetPassword;
